import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, Observable } from 'rxjs'
import { Outsider } from '../../models/outsider.interface'
import { environment } from '../../../environments/environment'

@Injectable({
    providedIn: 'root',
})
export class PersonService {
    private apiUrl = environment.service_1 + 'find-outsider/'

    constructor(private http: HttpClient) {}

    searchPerson(id: string): Observable<Outsider[]> {
        return this.http
            .get<Outsider[]>(this.apiUrl + `?identification=${id}`)
            .pipe(
                map((response) => response ?? []),
                catchError(() => [])
            )
    }
}
